import { render } from "./RemoteInspectionsTrustBlog.vue?vue&type=template&id=cf35d9d0&scoped=true"
import script from "./RemoteInspectionsTrustBlog.vue?vue&type=script&lang=js"
export * from "./RemoteInspectionsTrustBlog.vue?vue&type=script&lang=js"

import "./RemoteInspectionsTrustBlog.vue?vue&type=style&index=0&id=cf35d9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf35d9d0"]])

export default __exports__